import Api from '@/Api'

export default class SearchApi extends Api {
  /**
   * Requests the API to send a list of members
   * @param {Object} params - key/value pair to be provided as url query parameters
   * @param {String} params.groupId eg: "I9717208"
   * @param {String} params.groupCk eg"42186"
   * @param {String} params.subGroupId eg"1001"
   * @param {String} params.subGroupCk eg"57907"
   * @param {String} params.memberIdSource eg"CS"
   * @param {String} params.memberId eg: "2200025686"
   * @param {String} params.firstName eg: "SHIVA"
   * @param {String} params.lastName eg: "TEST"
   * @param {String} params.dateOfBirth eg: "1985-02-24T00:00:00-05:00"
   * @param {String} params.ssn eg: ""
   * @param {String} params.dateOfService eg""
   * @param {String} params.memberStatus eg"A"
   * @param {String} params.matchSearch eg"false"
   * @return {Promise} Promise with the results of the request or error
   */
  searchMembers = (params) => {
    return this.post('/api/v1/private/members/search', params)
  }

  /**
   * Requests the API to send a list of invoices
   * @param {Object} params - key/value pair to be provided as url query parameters
   * @param {String} params.groupCk - groupCk to search for
   * @param {String} params.subGroupGroupCk - subGroupCk to search for
   * @return {Promise} Promise with the results of the request or error
   */
  searchInvoices = (params) => {
    if (params.groupCk === undefined) {
      console.warn('Unable to search invoices, invalid groupCk', params)
      return
    }

    if (params.subGroupCk === undefined) {
      console.warn('Unable to search invoices, invalid subGroupCk', params)
      return
    }

    return this.get('/api/v1/private/invoices', params)
  }

  /**
   * Requests the API to send a list of users
   * @param {Object} params - key/value pair to be provided as url query parameters
   * @return {Promise} Promise with the results of the request or error
   */
  searchUsers = (params) => {
    return this.post('/api/v1/private/users/search', params)
  }

  /**
   * Requests the API to send a list of groups
   * @param {Object} params - key/value pair to be provided as url query parameters
   * @return {Promise} Promise with the results of the request or error
   */
  searchGroups = (params) => {
    if (params.id === undefined) {
      console.warn('id groupId must be passed to the API, even if it\'s empty')
      return
    }

    return this.post('/api/v1/private/groups', params)
  }
}
